module.exports = __webpack_public_path__ + "fonts/THICCCBOI-Medium.61fab15e.woff2";